import React from 'react';

const MachineHero = ({ name, productionName, type }) => {
	const getBadgeColor = () => {
		switch (type?.toUpperCase()) {
			case 'SMOOTHIE':
				return 'bg-green-500 text-white';
			case 'SOUP':
				return 'bg-orange-500 text-white';
			case 'FRAPPE':
				return 'bg-blue-500 text-white';
			case 'COMBO':
			default:
				return 'bg-indigo-500 text-white';
		}
	};

	return (
		<div className="surface-0 border-1 surface-border border-round-md p-3 mb-3">
			<div className="flex justify-content-between align-items-start mb-2">
				<div className="flex-1">
					<h1 className="text-xl font-semibold text-900 m-0 mb-2 line-height-3">{name || 'Unnamed Machine'}</h1>
					{productionName && <p className="text-sm text-600 m-0 font-mono">{productionName}</p>}
				</div>
				<span className={`px-2 py-1 border-round text-xs font-medium uppercase ${getBadgeColor()}`}>
					{type || 'COMBO'}
				</span>
			</div>
		</div>
	);
};

export default MachineHero;
